import styled from 'styled-components'


export const WallBackground = styled.div`
  box-shadow: 0px 0px 10px #484848;
  background-image: url(${props => props.src});
  background-size: ${(props) => props.size};
  background-repeat: no-repeat;
  background-position-x: ${(props) => props.posX};
  background-position-y: ${(props) => props.posY};
  align-self: center;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-height: 100vh;
  left: ${props => (props.isFull ? '0' : props.theme.sidebar.width)};

  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/components/WallBackground/theme.js